import React from 'react'
import { useState,useEffect } from 'react'


import Title from '../../../components/forms/title'
import New from '../../../components/forms/new'
import Item from './item'
import Searchbar from '../../../components/forms/searchbar'
import NavigationFunctions from '../../../functions/admin/onlinestore/navigation'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Menu = () => {
  const [Navigation,setNavigation] = useState([]);
  const [FilterNavigation,setFilterNavigation] = useState(Navigation);
  function filterFunction(value){
    if(value === ""){
      setFilterNavigation(Navigation);
    }
    else{
      const filtedNavigation = Navigation.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilterNavigation(filtedNavigation);
    }
  }
  const Delete = (id)=>{
    NavigationFunctions.Delete(id,toast,(data)=>{
      setNavigation(data);
      setFilterNavigation(data)
    })
  }

  useEffect(() => {
    NavigationFunctions.Get((data)=>{
      setNavigation(data);
      setFilterNavigation(data)
    })
  },[])
  return (
    <div className='form_container'>
      <Title Name='Navigation' BackURL = {null}/>
      <New to='add'/>
      <div className='form_table_container'>
        <Searchbar Filter={filterFunction}/>
        <div className='form_item_row_container title'>
          <div className='form_item_row_container_itemfull' style={{width:'15%'}}>
            <p>Name</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'15%'}}>
            <p>Type</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'35%'}}>
            <p>Url</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'15%'}}>
            <p>Parent</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'20%'}}>
            <p></p>
          </div>
        </div>
        {
          FilterNavigation.map((item)=>{
            return(
              <Item Obj = {item} key={item.id} Delete={Delete} />
            );
          })
        }
      </div>
      <ToastContainer />
    </div>
  )
}

export default Menu
